import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { FaceType } from '@blade-sxp/monitoring-center/utils/const';
import colors from '@/styles/color.scss';
import moment from 'moment';
import { useAlarmList } from '@blade-sxp/monitoring-center/pages/alarm/utils/useAlarmList';
export default /*#__PURE__*/ _defineComponent({
    __name: 'card-box',
    props: {
        item: null
    },
    setup(__props) {
        const props = __props;
        const { handleAlarmDetail } = useAlarmList();
        const activeBorderColor = colors.borderItemHover;
        const privacyMode = localStorage.getItem('privacyMode') || 'false';
        const faceMatch = computed(() => {
            return (FaceType.includes(props.item.incidentType) ||
                ((props.item.incidentType === 'INCIDENT_EVERYTHING_MATCHED' || props.item.incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
                    props.item.everythingAnnotation?.everythingAlertType === 'image'));
        });
        const getPanoramicImage = computed(() => {
            const { pedestrianAnnotation, faceAnnotation, automobileAnnotation, panoramicImage } = props.item;
            switch (true) {
                case Boolean(pedestrianAnnotation):
                    return pedestrianAnnotation.portraitCaptureImage ?? '';
                case Boolean(faceAnnotation):
                    return faceAnnotation.portraitCaptureImage ?? '';
                case Boolean(automobileAnnotation):
                    return automobileAnnotation.portraitCaptureImage ?? '';
                default:
                    return panoramicImage ?? '';
            }
        });
        const getThreshold = computed(() => {
            const { incidentType, pedestrianAnnotation, faceAnnotation, everythingAnnotation } = props.item;
            if (incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED')
                return (pedestrianAnnotation.value * 100).toFixed(2) + '%';
            if (incidentType === 'FACE_MATCH')
                return (faceAnnotation.value * 100).toFixed(2) + '%';
            if ((incidentType === 'INCIDENT_EVERYTHING_MATCHED' || incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
                everythingAnnotation.everythingAlertType === 'iamge') {
                return (everythingAnnotation.value * 100).toFixed(2) + '%';
            }
            return '';
        });
        const getPortraitCaptureImage = computed(() => {
            const { pedestrianAnnotation, faceAnnotation, automobileAnnotation, panoramicImage, everythingAnnotation } = props.item;
            return (pedestrianAnnotation?.portraitCaptureImage ??
                faceAnnotation?.portraitCaptureImage ??
                automobileAnnotation?.portraitCaptureImage ??
                everythingAnnotation?.captureSmallImage ??
                panoramicImage ??
                '');
        });
        const getPortraitImage = computed(() => {
            const { pedestrianAnnotation, faceAnnotation, automobileAnnotation, everythingAnnotation } = props.item;
            return (pedestrianAnnotation?.portraitImage ||
                faceAnnotation?.portraitImage ||
                automobileAnnotation?.vehicleImage ||
                everythingAnnotation.originImage ||
                '');
        });
        const formatTime = (time) => {
            if (!time)
                return '';
            return moment(parseInt(time)).format('yyyy-MM-DD HH:mm:ss');
        };
        const libraryName = (item) => {
            return (item.faceAnnotation?.libraryName ??
                item.pedestrianAnnotation?.libraryName ??
                item.automobileAnnotation?.libraryName ??
                item.taskConsist?.taskName ??
                '');
        };
        const getDeviceName = (deviceName) => {
            const arr = deviceName.split('/');
            return arr[arr.length - 1];
        };
        const getFrequencyDay = (item) => {
            return item?.faceAnnotation?.frequencyDay
                ? item.faceAnnotation.frequencyDay + this.$t('day') + item.faceAnnotation.frequencyCount + this.$t('times')
                : '';
        };
        return { __sfc: true, handleAlarmDetail, props, activeBorderColor, privacyMode, faceMatch, getPanoramicImage, getThreshold, getPortraitCaptureImage, getPortraitImage, formatTime, libraryName, getDeviceName, getFrequencyDay, BlurPicture };
    }
});
